import React from 'react';
import PropTypes from 'prop-types';

import propTypeTheme from 'utils/prop-type-theme';

import cn from 'classnames';
import Link from 'components/link';

const themes = {
  vertical: '-theme-vertical',
  verticalVacancies: '-theme-vertical -theme-vertical--vacancies'
};

const Metadata = ({ items, theme }) => (
  <dl className={cn('metadata', theme)}>
    {items &&
      items.map(item => (
        <React.Fragment key={item.label + item.text}>
          <div className="metadata--item">
            <dt>{`${item.label}:`}</dt>
            <dd
              className={cn({
                'metadata--data--disabled': item.isDisabled
              })}
            >
              {item.url ? <Link url={item.url} text={item.text} /> : item.text}
            </dd>
          </div>
        </React.Fragment>
      ))}
  </dl>
);

Metadata.defaultProps = {
  items: []
};

Metadata.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.exact({
      label: PropTypes.string,
      text: PropTypes.string,
      url: PropTypes.string,
      isDisabled: PropTypes.bool
    })
  ),
  theme: PropTypes.oneOf(Object.values(themes))
};

Metadata.propTypesMeta = 'exclude';

Metadata.themes = themes;

export default Metadata;
